import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCookie, setCookie } from './cookies';
export var COOKIE_MODAL_CLOSED_EVENT = 'cookieModalClosed';
export var DYNATRACE_CONSENT_COOKIE_NAME = 'permissionPerformance';
export var DYNATRACE_CONSENT_DISABLED = 'disabled';
export var DYNATRACE_CONSENT_ENABLED = 'enabled';
export var DYNATRACE_SYNC_COOKIE = 'dynatraceSessionReplayConsentSynced';
export var ONETRUST_DYNATRACE_CONSENT_GROUP = 'C0002';
export var ONETRUST_GROUPS_UPDATED_EVENT = 'OneTrustGroupsUpdated';
var DEFAULT_SYNC_EXPIRY_MINUTES = 60 * 24 * 365;
export var hasCustomDynatraceConsent = () => getCookie(DYNATRACE_CONSENT_COOKIE_NAME) === 'true';
export var hasOneTrustDynatraceConsent = () => {
  var _window$OnetrustActiv;
  return typeof window !== 'undefined' && ((_window$OnetrustActiv = window.OnetrustActiveGroups) === null || _window$OnetrustActiv === void 0 ? void 0 : _window$OnetrustActiv.includes(",".concat(ONETRUST_DYNATRACE_CONSENT_GROUP, ","))) === true;
};
export var getDynatraceConsentPaths = (language, country) => ["/".concat(language, "-").concat(country), "/".concat(country)];
export var syncDynatraceConsent = _ref => {
  var hasConsent = _ref.hasConsent,
    _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
    _ref$expiryMinutes = _ref.expiryMinutes,
    expiryMinutes = _ref$expiryMinutes === void 0 ? DEFAULT_SYNC_EXPIRY_MINUTES : _ref$expiryMinutes,
    _ref$paths = _ref.paths,
    paths = _ref$paths === void 0 ? ['/'] : _ref$paths,
    domain = _ref.domain;
  if (!isEnabled || typeof window === 'undefined' || !window.dtrum) {
    return false;
  }
  var nextState = hasConsent ? DYNATRACE_CONSENT_ENABLED : DYNATRACE_CONSENT_DISABLED;
  var currentState = getCookie(DYNATRACE_SYNC_COOKIE);
  if (currentState === nextState) {
    return false;
  }
  var methodName = hasConsent ? 'enableSessionReplay' : 'disableSessionReplay';
  var dtrumMethod = window.dtrum[methodName];
  if (!dtrumMethod) {
    return false;
  }
  if (hasConsent) {
    var _window$dtrum$enableS, _window$dtrum;
    (_window$dtrum$enableS = (_window$dtrum = window.dtrum).enableSessionReplay) === null || _window$dtrum$enableS === void 0 || _window$dtrum$enableS.call(_window$dtrum, false);
  } else {
    var _window$dtrum$disable, _window$dtrum2;
    (_window$dtrum$disable = (_window$dtrum2 = window.dtrum).disableSessionReplay) === null || _window$dtrum$disable === void 0 || _window$dtrum$disable.call(_window$dtrum2);
  }
  paths.forEach(path => {
    setCookie(DYNATRACE_SYNC_COOKIE, nextState, expiryMinutes, path, undefined, domain);
  });
  return true;
};
export var syncDynatraceConsentFromCookie = function syncDynatraceConsentFromCookie() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return syncDynatraceConsent(_objectSpread(_objectSpread({}, options), {}, {
    hasConsent: hasCustomDynatraceConsent()
  }));
};
export var syncDynatraceConsentFromOneTrust = function syncDynatraceConsentFromOneTrust() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return syncDynatraceConsent(_objectSpread(_objectSpread({}, options), {}, {
    hasConsent: hasOneTrustDynatraceConsent()
  }));
};